import gql from "graphql-tag";

//--------
// QUERIES
//--------

export const currentUserCart = gql`
  query currentUserCart($id: String!, $lang: String!) {
    currentusercartGraphql1View(
      filter: { langcode: $lang }
      contextualFilter: { user_id: $id }
    ) {
      results {
        ... on Cart {
          id
          fieldLineItemsReference {
            targetId
            entity {
              ... on NodeCartLineItem {
                fieldSizeName
                fieldLineItemNotes
                fieldProductReference {
                  targetId
                  entity {
                    ... on Product {
                      name
                      fieldCode
                      fieldSizes {
                        targetId
                        entity {
                          ... on ParagraphSize {
                            fieldSizeName
                          }
                        }
                      }
                      fieldPrices {
                        entity {
                          ... on ParagraphPrice {
                            fieldPriceAmount
                            fieldCurrency
                          }
                        }
                      }
                      fieldProductCategory {
                        targetId
                        entity {
                          entityLabel
                        }
                      }
                      fieldMaxShopQuantity
                      fieldMandatoryNote
                      fieldProductImages {
                        url
                      }
                    }
                  }
                  quantity
                }
              }
            }
          }
        }
      }
    }
  }
`;

//----------
// MUTATIONS
//----------

export const createNodeCartLineItem = gql`
  mutation createNodeCartLineItem(
    $title: String!
    $targetIdProduct: String!
    $quantity: String!
  ) {
    createNodeCartLineItem(
      input: {
        title: $title
        status: "1"
        fieldProductReference: {
          targetId: $targetIdProduct
          quantity: $quantity
        }
      }
    ) {
      entity {
        ... on NodeCartLineItem {
          nid
        }
      }
      errors
      violations {
        message
        path
        code
      }
    }
  }
`;

export const createNodeCartLineItemWithSizes = gql`
  mutation createNodeCartLineItemWithSizes(
    $title: String!
    $targetIdProduct: String!
    $quantity: String!
    $size: String!
  ) {
    createNodeCartLineItem(
      input: {
        title: $title
        status: "1"
        fieldProductReference: {
          targetId: $targetIdProduct
          quantity: $quantity
        }
        fieldSizeName: $size
      }
    ) {
      entity {
        ... on NodeCartLineItem {
          nid
        }
      }
      errors
      violations {
        message
        path
        code
      }
    }
  }
`;

export const updateNodeCartLineItem = gql`
  mutation updateNodeCartLineItem(
    $id: String!
    $nid: String!
    $quantity: String!
  ) {
    updateNodeCartLineItem(
      id: $id
      input: { fieldProductReference: { targetId: $nid, quantity: $quantity } }
    ) {
      errors
      violations {
        path
        message
      }
      entity {
        ... on NodeCartLineItem {
          nid
          title
          fieldLineItemNotes
          fieldProductReference {
            targetId
            quantity
          }
        }
      }
    }
  }
`;

export const addNotesToCartLineItem = gql`
  mutation addNotesToCartLineItem($id: String!, $note: String!) {
    updateNodeCartLineItem(id: $id, input: { fieldLineItemNotes: $note }) {
      errors
      violations {
        path
        message
      }
      entity {
        ... on NodeCartLineItem {
          nid
          title
          fieldLineItemNotes
          fieldProductReference {
            targetId
            quantity
          }
        }
      }
    }
  }
`;

export const deleteNodeCartLineItem = gql`
  mutation deleteCartLine($id: String!) {
    deleteNode(id: $id) {
      errors
      violations {
        message
        path
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/cart.js